/* Gro Worm redesign: videos with mute buttons, product page form, gallery and sticky bar. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noAutoplay = reduceMotion;
  try { noAutoplay = noAutoplay || sessionStorage.getItem('gxNoAutoplay') === '1'; } catch (e) {}

  /* ---------- videos ----------
     <figure data-gx-video data-gx-name="the worm" [data-gx-sound-first]>
       <video data-src="..." muted loop playsinline preload="none"></video>
       <button data-gx-sound aria-pressed="true">...</button>
     Loads only when near the viewport, plays muted while visible, pauses when off screen.
     data-gx-sound-first tries to start with sound (browsers usually refuse until the
     visitor has interacted, so it falls back to muted). */
  function setupVideo(box) {
    var video = box.querySelector('video');
    var btn = box.querySelector('[data-gx-sound]');
    var name = box.getAttribute('data-gx-name') || 'video';
    var wantSound = box.hasAttribute('data-gx-sound-first');
    var userMuted = null;
    if (!video) return;

    function paint() {
      var muted = video.muted;
      if (!btn) return;
      btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      btn.setAttribute('aria-label', (muted ? 'Unmute ' : 'Mute ') + name);
    }

    function load() {
      if (video.getAttribute('src') || !video.dataset.src) return;
      video.src = video.dataset.src;
    }

    function start() {
      load();
      if (noAutoplay && userMuted === null) return;
      var trySound = wantSound && userMuted === null;
      video.muted = !trySound && userMuted !== false;
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          video.muted = true;
          paint();
          video.play().catch(function () {});
        });
      }
      paint();
    }

    if (btn) {
      btn.addEventListener('click', function () {
        load();
        var mute = !video.muted;
        userMuted = mute;
        video.muted = mute;
        if (!mute) {
          if (box.hasAttribute('data-gx-restart')) video.currentTime = 0;
          video.play().catch(function () {});
        }
        paint();
      });
    }
    video.addEventListener('volumechange', paint);
    paint();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) start();
          else if (!video.paused) video.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(box);
    } else {
      start();
    }
  }

  /* ---------- cart ---------- */
  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return j; });
    }).then(function () {
      return fetch('/cart?view=compare', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (window.wetheme && typeof window.wetheme.toggleRightDrawer === 'function') {
        window.wetheme.toggleRightDrawer('cart', true, { cart: cart });
      } else {
        window.location.href = '/cart';
      }
      return cart;
    });
  }

  /* cart drawer "Add Plant Boost" suggestion: the drawer re-renders, so listen at document level */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gx-upsell]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true; b.textContent = 'Adding…';
    addToCart(b.getAttribute('data-gx-upsell'), 1).catch(function () {
      b.disabled = false; b.textContent = 'Add';
    });
  });

  function setupQuick(form) {
    var btn = form.querySelector('button[type=submit]');
    function go(e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(form.querySelector('input[name=id]').value, 1).then(function () {
        btn.disabled = false; btn.textContent = label;
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        window.alert(err.message);
      });
    }
    btn.addEventListener('click', go);
    form.addEventListener('submit', go);
  }

  /* ---------- product page ---------- */
  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    return (fmt || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function setupProduct(root) {
    var form = root.querySelector('[data-gx-form]');
    if (!form) return;
    var dataEl = root.querySelector('[data-gx-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var fmt = root.getAttribute('data-money-format');
    var idInput = form.querySelector('input[name="id"]');
    var priceEls = root.querySelectorAll('[data-gx-price]');
    var buttons = root.querySelectorAll('[data-gx-add]');
    var msg = root.querySelector('[data-gx-msg]');
    var qty = form.querySelector('input[name="quantity"]');

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    function update(v) {
      if (!v) return;
      idInput.value = v.id;
      var html = money(v.price, fmt);
      if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price, fmt) + '</s>';
      priceEls.forEach(function (el) { el.innerHTML = html; });
      /* "£15.79 a bag" under the price for multi-bag pack sizes */
      var perEl = root.querySelector('[data-gx-perbag]');
      if (perEl) {
        var n = parseInt(String(v.title), 10);
        if (/bag/i.test(v.title) && n > 1) {
          perEl.textContent = money(Math.round(v.price / n), fmt) + ' a bag';
          perEl.hidden = false;
        } else {
          perEl.hidden = true;
        }
      }
      buttons.forEach(function (b) {
        b.disabled = !v.available;
        b.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      if (v.featured_media_id) showMedia(v.featured_media_id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      } catch (e) {}
    }

    root.querySelectorAll('input[name="gx-variant"]').forEach(function (r) {
      r.addEventListener('change', function () { update(variantById(r.value)); });
    });

    root.querySelectorAll('[data-gx-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-gx-step'), 10));
        qty.value = n;
      });
    });

    /* gallery */
    var stageImg = root.querySelector('[data-gx-stage-img]');
    var thumbs = root.querySelectorAll('[data-gx-thumb]');
    function showMedia(mediaId) {
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-gx-thumb') === String(mediaId);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && stageImg) {
          stageImg.src = t.getAttribute('data-src');
          stageImg.srcset = t.getAttribute('data-srcset') || '';
          stageImg.alt = t.getAttribute('data-alt') || '';
          stageImg.classList.toggle('is-photo', t.hasAttribute('data-photo'));
        }
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-gx-thumb')); });
    });

    /* AJAX add to cart, then open the theme's own cart drawer */
    var busy = false;
    function submitAdd(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (busy) return;
      busy = true;
      var label = buttons.length ? buttons[0].textContent : '';
      buttons.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
      if (msg) msg.textContent = '';
      addToCart(idInput.value, parseInt(qty.value, 10) || 1).then(function () {
        busy = false;
        buttons.forEach(function (b) { b.disabled = false; b.textContent = label; });
      }).catch(function (err) {
        busy = false;
        buttons.forEach(function (b) { b.disabled = false; b.textContent = label; });
        if (msg) msg.textContent = err.message;
      });
    }
    /* Handle the click on our own buttons: apps on the store intercept product form
       submits, so we don't rely on the submit event reaching us. */
    buttons.forEach(function (b) { b.addEventListener('click', submitAdd); });
    form.addEventListener('submit', submitAdd);

    /* phone sticky bar: shows while the main Add to cart button is off screen */
    var bar = root.querySelector('[data-gx-satc]');
    var main = root.querySelector('[data-gx-add-main]');
    if (bar && main) {
      var ticking = false;
      var check = function () {
        ticking = false;
        var r = main.getBoundingClientRect();
        var on = r.bottom < 0 || r.top > window.innerHeight;
        bar.classList.toggle('is-on', on);
        /* lets CSS move the Rewards launcher and Feefo tab out of the bar's way on phones */
        document.body.classList.toggle('gx-satc-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelector('button').tabIndex = on ? 0 : -1;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; setTimeout(check, 50); }
      }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  function init() {
    document.querySelectorAll('[data-gx-video]').forEach(setupVideo);
    document.querySelectorAll('[data-gx-product]').forEach(setupProduct);
    document.querySelectorAll('form[data-gx-quick]').forEach(setupQuick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-gx-video]').forEach(setupVideo);
    e.target.querySelectorAll('[data-gx-product]').forEach(setupProduct);
    e.target.querySelectorAll('form[data-gx-quick]').forEach(setupQuick);
  });
})();
